import React, { useRef, useEffect, useState } from 'react';
import { useDivDimensions } from '../../utils/WindowSize';
import { createMap } from '../Charts/D3/helpers';
import { drawBogota } from '../Charts/D3/drawBogota';
import { select } from '../../rematch/store';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import 'maplibre-gl/dist/maplibre-gl.css';
import './Main.css';
import { options } from '../../assets/cityOptions.json'
import { Map, Source, Layer, Popup, Marker  } from '@vis.gl/react-maplibre'

const Main = props => {
    const
        {
            id,
            dispatch,
            citiesDispatch,
            sectorDispatch,
            estratosSelect,
            estratosDispatch,
            locationsDispatch,
            homesDispatch,
            sliderValue
        } = props,
        mapRef = useRef(),
        containerRef = useRef(),
        { width, height } = useDivDimensions(containerRef),
        { sector } = sectorDispatch,
        { city } = citiesDispatch,
        { points, categories, viewedCoordinates } = locationsDispatch,
        { geography, isLoading, neighborhoodPolygon } = estratosDispatch,
        types = categories?.map(o => o.label.toUpperCase() ) || [],
        [popupInfo, setPopupInfo] = useState({ longitude: -100, latitude: 0, name: null, description: null }),
        // city = options[0],
        neighborhoodStyle = {
            source: 'neighborhood-shape',
            id: 'neighborhood_fill',
            type: 'fill',
            paint: {
                'fill-color': 'steelblue',
                'fill-opacity': 0.6
            }
        },
        amenitiesStyle = {
            source: 'amenities-points',
            id: 'amenities-circle',
            type: 'circle',
            paint: {
                'circle-color': [
                    'get','fill'
                ]
            },
            filter: [
                'in',
                ['get', 'type'],
                ['literal', types]
            ]
        },
        amenitiesTextStyle = {
            source: 'amenities-points',
            id: 'amenities-text',
            type: 'symbol',
            layout: {
                'text-field': ['get', 'name'],
                'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
                'text-size': 13,
                'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
                'text-radial-offset': 0.5,
                'text-justify': 'auto'
            },
            paint: {
                'text-color': '#555555',
                'text-halo-color': '#ffffff',
                'text-halo-width': 2,
                'text-halo-blur': 0.5
            }
        },
        lodgingStyle = {
            source: 'lodging-points',
            id: 'lodging-circle',
            type: 'symbol',
            layout: {
                'text-field': ['get', 'pricing'],
                'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
                'text-size': [
                    'case',
                    ['==', ['get', 'id'], viewedCoordinates.id], 14,
                    12
                ],
                'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
                'text-radial-offset': 0.5,
                'text-justify': 'auto'
            },
            paint: {
                'text-color': [
                    'case',
                    ['==', ['get', 'id'], viewedCoordinates.id], 'red',
                    'black'
                ],
                'text-halo-color': '#ffffff',
                'text-halo-width': 2,
                'text-halo-blur': 0.5
            },
            filter: [
                '<',
                ['get', 'amount'],
                sliderValue
            ]

        },
        onClick = e => {
            const {
                features,
                point: { x, y }
            } = e
            if(features.length > 0){
                const { lng, lat } = e.lngLat
                e.originalEvent.stopPropagation()
                setPopupInfo({
                    longitude: lng,
                    latitude: lat,
                    name: features[0].properties.name,
                    description: features[0].properties.description,
                    image: features[0].properties.image
                })
            }
        },
        movePage = (evt, { coordinates, id} ) => {
            const [ lng, lat ] = coordinates
            if (homesDispatch?.listings.find(o => o.id))  {
                dispatch.homes.clickedListing(homesDispatch?.listings.find(o => o.id))
            }
        }
    ;
    useEffect(() => {
        dispatch.estratos.loadEstratosData();
    },[])
    ;
    useEffect(() => {
        const neighborhoodFilter = estratosSelect.geographyFilter;
        const testFilter = estratosSelect.estratoValueFilter;
        // console.log(_.uniq(testFilter(geography?.estratos), d => d.properties.SectCatast).map( d => d.properties.SectCatast ))

        if (!isLoading) dispatch.estratos.extractSector({ sector : sector, filter: neighborhoodFilter });
    },[!isLoading])
    ;
    useEffect(() => {
        !locationsDispatch.isLoading && createMap( {
            id,
            ...city,
            sector,
            width: width,
            height: height,
            ...geography,
            neighborhood: neighborhoodPolygon,
            ...homesDispatch,
            points: points
        }, drawBogota );
    },[ estratosDispatch.neighborhoodPolygon && !homesDispatch.isLoading ])
    ;
    useEffect(() => {
        const map = mapRef.current
        if (map) {
            map.flyTo({
                center: viewedCoordinates?.coordinates, // [lng, lat]
                zoom: 15,
                bearing: 0,
                pitch: 45,
                speed: 1.2, // Controls how fast the flight is
                curve: 1.42, // The "arc" of the zoom out/in
                essential: true // If true, the animation won't be interrupted by user settings
            });
        }
    },[viewedCoordinates])
    ;
    return (
        <div id={ id } ref={ containerRef }>
            <Map
                ref={ mapRef }
                initialViewState={{
                    latitude: 4.652702111230982,
                    longitude: -74.0563192829445,
                    zoom: 14
                }}
                // style={{ width: '80%', height: '80%' }}
                onClick={onClick}
                interactiveLayerIds={['lodging-circle']}
                mapStyle={'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json'}
            >
                <Source id='neighborhood-shape' type='geojson' data={{
                    type : 'Feature', geometry : { ...neighborhoodPolygon }
                }}/>
                <Layer {...neighborhoodStyle }/>
                <Source id='amenities-points' type='geojson' data={{
                    type : 'FeatureCollection', features: points?.map(p => ({
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': p?.coordinates
                        },
                        'properties': {
                            'name': p?.name,
                            'fill': p?.fill,
                            'sector': p?.sector,
                            'type': p?.type
                        }
                    }))
                }}/>
                <Layer {...amenitiesStyle }/>
                <Layer {...amenitiesTextStyle }/>
                <Source id='lodging-points' type='geojson' data={{
                    type : 'FeatureCollection', features: homesDispatch?.listings?.map(p => ({
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [p?.location?.lng, p?.location?.lat]
                        },
                        'properties': {
                            'amount': p?.pricing?.rate?.amount,
                            'pricing': p?.pricing?.rate?.amount_formatted,
                            'id': p?.id,
                            'name': p?.name,
                            'description': p?.sectionedDescription?.space,
                            'image': p?.photos[0].large,
                        }
                    }))
                }}/>
                <Layer {...lodgingStyle }/>
                <Marker
                    longitude={-74.0760}
                    latitude={4.5981}
                    anchor="bottom"
                    onMouseEnter={e => {
                        const {
                            features,
                            point: { x, y }
                        } = e
                    }}
                >
                    📍
                </Marker>
                {popupInfo && (
                    <Link
                        to={`/rooms`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        <Popup
                            longitude={popupInfo.longitude}
                            latitude={popupInfo.latitude}
                            anchor="top"
                            onClose={() => setPopupInfo(null)}
                            closeOnClick={false}
                            offset={10}
                        >
                            <div
                                onClick={ evt => movePage(evt, { id: popupInfo.id, coordinates: [popupInfo.longitude, popupInfo.latitude] }) }
                            >
                                <h3>{popupInfo.name}</h3>
                                <img src={popupInfo.image} width={'100px'}/>
                                <p>{popupInfo.description}</p>
                            </div>
                        </Popup>
                      </Link>
                )}
            </Map>
        </div>
    )
}

const mapStateToProps = () => (
    dispatch => {
        return {
            citiesDispatch: dispatch.cities,
            sectorDispatch: dispatch.sector,
            estratosDispatch: dispatch.estratos,
            locationsDispatch: dispatch.locations,
            estratosSelect: select.estratos,
            homesDispatch: dispatch.homes
        }
    }
)

export default connect(mapStateToProps)(Main);
